module.exports = __webpack_public_path__ + "img/3.e2dd61c0.svg";